import { Injectable } from "@angular/core";
import { FetchStatusSelector } from "@obg/ngrx-utils";

import { CoreState } from "../../state";
import { VerificationStatus } from "../auth-transaction.model";

import { ACTION_PREFIX } from "./dga-auth-transaction.action";
import { ExperianData, OpenIdConnectResponse } from "./dga-auth-transaction.model";

@Injectable({
	providedIn: "root",
})
export class DgaAuthTransactionSelector {
	getCpr() {
		return (state: CoreState): string | undefined => state.dgaAuthTransaction.cpr;
	}

	getErrorCode() {
		return (state: CoreState): string | undefined => state.dgaAuthTransaction.errorCode;
	}

	getXmlDSig() {
		return (state: CoreState): string | undefined => state.dgaAuthTransaction.xmlDSig;
	}

	getExperianData() {
		return (state: CoreState): ExperianData | undefined => state.dgaAuthTransaction.experianData;
	}

	getLastStatus() {
		return (state: CoreState): VerificationStatus | undefined => state.dgaAuthTransaction.verificationStatus;
	}

	getAuthenticationToken() {
		return (state: CoreState): string | undefined => state.dgaAuthTransaction.authenticationToken;
	}

	getIsExperianDataSubmitted() {
		return (state: CoreState): boolean | undefined => state.dgaAuthTransaction.experianDataSubmitted;
	}

	getIsLoginToRegistrationFlow() {
		return (state: CoreState): boolean | undefined => state.dgaAuthTransaction.loginToRegistrationFlow;
	}

	isBusy() {
		return (state: CoreState): boolean => FetchStatusSelector.isBusy(ACTION_PREFIX)(state);
	}

	getOpenIdConnectUrl() {
		return (state: CoreState): OpenIdConnectResponse | undefined => state.dgaAuthTransaction.openIdConnectUrl;
	}
}
